import React from "react";

import DashboardSidebarMenu from "../../components/controls/DashboardSideBarMenu";
import { getAdminMenus } from "../../contexts/AdminMenus";
import { useTranslation } from "react-i18next";

function AdminDashboard() {
  const { t } = useTranslation();
  const title = t("admin.title");
  const menus = getAdminMenus();
  return (
    <div className="flex">
      {/* Sidebar */}
      <DashboardSidebarMenu title={title} menus={menus} />

      {/* Main Content */}
      <div className="flex-1 p-6">
        <h1>Bienvenue dans le tableau de bord</h1>
      </div>
    </div>
  );
}

export default AdminDashboard;
